import React from "react";
import "./WorkExperience.css";
import WorkExperienceImg from "../../assets/WorkExperience-landscape.png";

const WorkExperience = () => {
  return (
    <section id="work-experience" className="work-experience">
      <h2>Work experience</h2>
      <h3>Financial Times (2022–Present)</h3>
      <div className="work-experience__image">
        <img src={WorkExperienceImg} alt="Work Experience" />
      </div>
    </section>
  );
};

export default WorkExperience;
